import {EstabEnderecoComplementarModel} from '../identificacao/estab-endereco-complementar.model';
import {Guid} from 'guid-typescript';

export class IEstabSevico {
    id: string;
    idServico: string;
    servico: string;
    servicoObj: any;
    idClassificacao: string;
    classificacao: string;
    classificacaoObj: any;
    idPrestador: string;
    prestador: string;
    cnes: string;
    nomeFantasia: string;
    idAtendimento: string;
    atendimento: string;
    atendeSUS: string;
}

export class IEndeSevico {
    id?: string;
    idServico?: string;
    servico?: string;
    classificacao?: string;
}

export class EstabSevicoModel {
    id?: string;
    idServico?: string;
    servico?: string;
    servicoObj?: any;
    idClassificacao?: string;
    classificacao?: string;
    classificacaoObj?: any;
    idPrestador?: string;
    prestador?: string;
    cnes?: string;
    nomeFantasia?: string;
    idAtendimento?: string;
    atendimento?: string;
    atendeSUS?: string;
    enderecosComplementares?: EstabEnderecoComplementarModel[];

    constructor(obj: IEstabSevico) {
        this.id = obj.id ? obj.id : Guid.create().toString();
        this.idServico = obj.idServico ? obj.idServico : '';
        this.servico = obj.servico ? obj.servico : '';
        this.servicoObj = obj.servicoObj ? obj.servicoObj : {};
        this.idClassificacao = obj.idClassificacao ? obj.idClassificacao : '';
        this.classificacao = obj.classificacao ? obj.classificacao : '';
        this.servicoObj = obj.servicoObj ? obj.servicoObj : {};
        this.classificacaoObj = obj.classificacaoObj ? obj.classificacaoObj : '';
        this.idPrestador = obj.idPrestador ? obj.idPrestador : '';
        this.prestador = obj.prestador ? obj.prestador : '';
        this.cnes = obj.cnes ? obj.cnes : '';
        this.nomeFantasia = obj.nomeFantasia ? obj.nomeFantasia : '';
        this.idAtendimento = obj.idAtendimento ? obj.idAtendimento : '';
        this.atendimento = obj.atendimento ? obj.atendimento : '';
        this.atendeSUS = obj.atendeSUS ? obj.atendeSUS : '';
        this.enderecosComplementares = [];
    }
}

export class AtendimentoSus {
    codigo: string;
    descricao: string;
}

export class Servico {
    codigo: string;
    descricao: string;
}

export class PrestadoPor {
    codigo: string;
    descricao: string;
}

export class ClassificacaoServico {
    id: string;
    codigo: string;
    descricao: string;
    servico: Servico;
}

export class ServicoEspecializadoModel {
    atendimentoSUS: AtendimentoSus;
    classificacaoServico: ClassificacaoServico;
    id: string;
    prestadoPor: PrestadoPor;
}
